import styled from "styled-components";

const H1 = styled.h1`
  width: 100%;
  font-size: 48px;
  padding: 2rem;
  margin: 0;
`;

export default H1;
